import { UserManager } from 'oidc-client'
import store from '@/store'

const userManager = new UserManager({
  authority: process.env.VUE_APP_AUTHORITY,//认证服务器
  client_id: 'admin.ui',//表示客户端的ID，必选项
  scope: 'openid profile admin.server.api',
  response_type: 'id_token token',//表示授权类型，必选项
  redirect_uri: window.location.origin + '/callback',//表示重定向URI，认证服务器回调的客户端页面。可选项
  post_logout_redirect_uri: window.location.origin,
  loadUserInfo: false
  // revokeAccessTokenOnSignout: true,
  // automaticSilentRenew: true,
  // silent_redirect_uri: window.location.origin + '/refresh'
  // userStore: new WebStorageStateStore()
})

userManager.events.addUserSignedOut(async() => {
  store.dispatch('user/logout');//dispatch: 含有异步操作存储;commit:同步操作存储
  account.logout()
})

class Account {
  async login() {
    await userManager.signinRedirect()//登录
  }

  async logout() {
    await userManager.signoutRedirect()//退出登录
  }

  async getAcessToken() {
    const user = await userManager.signinRedirectCallback()//callback
    return user ? user.access_token : null
  }

  async getNewAcessToken() {
    const user = await userManager.signinSilentCallback()
    return user ? user.access_token : null
  }
}

const account = new Account()

export const getAcessToken = async() => account.getAcessToken()
export const getNewAcessToken = async() => account.getNewAcessToken()
export const login = async() => account.login()
export const logout = async() => account.logout()

export default account
